import React, { useState } from "react"
import { ChevronDown, ChevronUp } from "react-feather"
import { useDispatch } from "react-redux"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { updateScoreCounter } from "../../../redux/actions/actions"
import styles from "../ScoreCounter.module.scss"

function ScoreViewer({ score }) {
	const dispatch = useDispatch()
	const [isOpen, setIsOpen] = useState(false)

	const onIncrement = (team) => {
		if (score[team] === 0 || score[team] === 15) {
			dispatch(updateScoreCounter(team, 15))
		} else if (score[team] === 30) {
			dispatch(updateScoreCounter(team, 10))
		} else if (score[team] === 40) {
			const otherTeam = team === "homeTeam" ? "awayTeam" : "homeTeam"
			if (score[otherTeam] === 40) {
				dispatch(updateScoreCounter(team, 10))
			} else if (score[otherTeam] === 50) {
				dispatch(updateScoreCounter(otherTeam, -10))
			} else {
				setIsOpen(true)
			}
		} else if (score[team] === 50) {
			setIsOpen(true)
		}
	}
	const onDecrement = (team) => {
		const otherTeam = team === "homeTeam" ? "awayTeam" : "homeTeam"
		if (score[otherTeam] === 50) {
			dispatch(updateScoreCounter(otherTeam, -10))
		}
		if (score[team] === 30 || score[team] === 15) {
			dispatch(updateScoreCounter(team, -15))
		} else if (score[team] === 40 || score[team] === 50) {
			dispatch(updateScoreCounter(team, -10))
		}
	}

	const createPointArrows = (team) => {
		return (
			<div className={styles.columnFlex}>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onIncrement(team)}
				>
					<ChevronUp />
				</Button.Ripple>
				<Button.Ripple
					color="flat-primary"
					size="sm"
					onClick={() => onDecrement(team)}
				>
					<ChevronDown />
				</Button.Ripple>
			</div>
		)
	}

	return (
		<div className={styles.rowFlex}>
			{createPointArrows("homeTeam")}
			{score.homeTeam == 40 && score.awayTeam == 40 ? (
				<h2>Deuce</h2>
			) : score.homeTeam == 40 && score.awayTeam == 50 ? (
				<h2>40 - Adv.</h2>
			) : score.homeTeam == 50 && score.awayTeam == 40 ? (
				<h2>Adv. - 40</h2>
			) : (
				<h2>
					{score.homeTeam} - {score.awayTeam}
				</h2>
			)}
			{createPointArrows("awayTeam")}
			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered modal-sm"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Nije moguće
				</ModalHeader>
				<ModalBody>
					<p>U tenisu se nemože imati više bodova od 40</p>
					<p>
						Ako želite proglasiti pobjednika ovog game-a, morate kliknut
						na Pobjednik Gamea
					</p>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple
						color="secondary"
						outline
						className="btn-sm-block"
						onClick={() => setIsOpen(false)}
					>
						OK
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</div>
	)
}

export default ScoreViewer
